export default __webpack_public_path__ + "ed28a725cb244503bfbe766bec084298.svg";